import { PmsIntegration, PmsIntegrationErrorCode } from '../../axios/pms/pmsIntegrations/types'
import { SET_PMS_INTEGRATION, SET_PMS_INTEGRATION_ERROR_CODE, SET_PMS_INTEGRATION_IS_SAVING } from '../../actionTypes/pmsIntegration'

export const setPmsIntegration = (value: PmsIntegration | null) => ({ type: SET_PMS_INTEGRATION, value })

export const setPmsIntegrationIsSaving = (value: boolean) => ({ type: SET_PMS_INTEGRATION_IS_SAVING, value })

export const setPmsIntegrationErrorCode = (value: PmsIntegrationErrorCode | null) => ({ type: SET_PMS_INTEGRATION_ERROR_CODE, value })
